export default __webpack_public_path__ + "22a8b5005857e1ca949b6586bc279ed5.svg";